<template>
    <ion-card mode="ios" style="margin: 15px 0; background: #fff">
        <ion-card-header>
            <slide-y-up-transition :duration="700">
                <h6 v-show="show" class="text-up m-0">Twój postęp</h6>
            </slide-y-up-transition>
        </ion-card-header>
        <ion-card-content style="padding-top: 0">
            <ion-progress-bar :value="progressValue" style="height:15px"></ion-progress-bar>
            <slide-y-up-transition :duration="500" :delay="200">
                <p v-show="show" style="margin: 10px 0; font-size: 12px">
                    <strong>{{ getProfile.number_pass_tests }} z {{ getProfile.number_trainings_tests }}</strong>
                </p>
            </slide-y-up-transition>
        </ion-card-content>
    </ion-card>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'CardTrainingProgress',
        data() {
            return {
                show: false
            }
        },
        computed: {
            ...mapGetters('profile', ['getProfile']),

            progressValue(){
                return this.getProfile.number_pass_tests / this.getProfile.number_trainings_tests
            }
        },
        mounted() {
            this.show = true;
        },
    }
</script>